import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Checkbox from 'components/Checkbox';
import Link from 'components/Link';
import styles from './SignupForm.module.scss';

const CheckboxLink = ({ url, text }) => (
  <Link
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => e.stopPropagation()}
  >
    {text}
  </Link>
);

CheckboxLink.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default function CheckboxField({ value, onChange, error }) {
  return (
    <Checkbox
      checked={value}
      className={classnames(styles.checkboxWrap, {
        [styles.error]: error,
      })}
      onChange={() => onChange(!value)}
      label={
        <span>
          I accept xMatters&apos;&nbsp;
          <CheckboxLink
            url="https://www.xmatters.com/policy/terms-conditions/"
            text="Terms and Conditions"
          />
          &nbsp;and acknowledge that my information will be used in accordance
          with xMatters&apos;&nbsp;
          <CheckboxLink
            url="https://www.everbridge.com/about/legal/everbridge-global-privacy-notice/"
            text="Privacy Policy"
          />
        </span>
      }
    />
  );
}

CheckboxField.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
};
